import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Row, Button, Input, Select } from 'antd';
import { Controller, useForm } from 'react-hook-form';

import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import GetField from '../Components/GetField';
import { getUser, clearUser, getRoleIds, clearRoleIds } from '../Actions';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const AntInputTextArea = GetField(Input.TextArea);

const { Option } = Select;

const UpdateUser = props => {
  const { classes, match } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, reset } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const user = useSelector(state => state.user);
  const roleIds = useSelector(state => state.roleIds);

  useEffect(() => {
    dispatch(getRoleIds());
    dispatch(getUser(match.params.id));
    return () => {
      dispatch(clearRoleIds());
      dispatch(clearUser());
    };
  }, []);

  useEffect(() => {
    reset(user);
  }, [user]);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.put(`/users/${match.params.id}`, formValues);
      successNotification('User updated');
      history.push('/users/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="User"
        moduleLink="/users/list"
        subModuleName="Update"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Email"
                  placeholder="Email"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Phone"
                  placeholder="Phone"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Address"
                  placeholder="Address"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="roleId"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="Role"
                  placeholder="Select role"
                  {...field}
                >
                  {roleIds.map(role => (
                    <Option key={role.id} value={role.id}>
                      {role.role}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="comment"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

UpdateUser.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateUser);
